module.exports = __webpack_public_path__ + "static/media/W06F0004.3665921d.svg";